import { getPreviousRoute } from "@/router";

/**
 * The ONE back-navigation rule, used by the PageHeader back arrow AND by
 * "save then leave" flows that previously called $router.go(-1) directly:
 *  1. a known in-app previous page -> real history back;
 *     ...unless it was a create form (already submitted - never reopen it);
 *  2. otherwise (deep link / refresh) -> the breadcrumb parent;
 *  3. otherwise the caller's fallback route name (optional);
 *  4. otherwise the dashboard.
 */
export function goBackSmart(router, route, fallbackName) {
  const previous = getPreviousRoute();
  const previousIsCreate = previous && String(previous.name || "").endsWith("-create");
  if (previous && previous.name && !previousIsCreate && previous.path !== route.fullPath) {
    router.back();
    return;
  }

  const crumb = route.meta && route.meta.breadcrumb;
  if (crumb && crumb.parent) {
    router.push({ name: crumb.parent, params: route.params }).catch(() => {});
    return;
  }

  if (fallbackName && fallbackName.trim()) {
    router.replace({ name: fallbackName });
    return;
  }

  router.push({ name: "dashboard" }).catch(() => {});
}
